import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllFunctionalities = async (context) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/staff/functionality/getAllFunctionality`,
    {
      headers: setHeaders(context),
    },
  );
  return response;
};

export const getUserPermissions = async (userId, context) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/staff/permission/${userId}`,
    { headers: setHeaders(context) },
  );
  return response;
};

export const getUserPermissionsLabel = async () => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/staff/permission/me/label`,
    { headers: setHeaders(), withCredentials: true },
  );
  return response;
};

export const assignePermissions = async (paylod, context) => {
  const response = await axios.post(
    `${apiPaths.baseUrl}/api/staff/permission/assign`,
    paylod,
    {
      headers: setHeaders(context),
    },
  );
  return response;
};
